// InstructorStep.tsx
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";


import { TrainingInput } from "./types";

interface InstructorStepProps {
  newTraining: Partial<TrainingInput>;
  setNewTraining: (training: Partial<TrainingInput>) => void;
}

const InstructorStep: React.FC<InstructorStepProps> = ({ newTraining, setNewTraining }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="instructor-name">Instructor Name *</Label>
        <Input
          id="instructor-name"
          value={newTraining.instructor?.name || ""}
          onChange={(e) =>
            setNewTraining({
              ...newTraining,
              instructor: { ...newTraining.instructor, name: e.target.value },
            })
          }
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="instructor-email">Instructor Email *</Label>
        <Input
          id="instructor-email"
          type="email"
          value={newTraining.instructor?.email || ""}
          onChange={(e) =>
            setNewTraining({
              ...newTraining,
              instructor: { ...newTraining.instructor, email: e.target.value },
            })
          }
          required
        />
      </div>
      <div className="space-y-2 md:col-span-2">
        <Label htmlFor="instructor-specialization">Specialization *</Label>
        <Input
          id="instructor-specialization"
          value={newTraining.instructor?.specialization || ""}
          onChange={(e) =>
            setNewTraining({
              ...newTraining,
              instructor: { ...newTraining.instructor, specialization: e.target.value },
            })
          }
          required
        />
      </div>
    </div>
  );
};

export default InstructorStep;